<script setup>
import InputError from "@/Components/InputError.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";
import InputField from "@/Components/InputField.vue";
import InputLabel from "@/Components/InputLabel.vue";

import { defineProps, ref, computed, watch } from "vue";
import Swal from "sweetalert2";
import { useForm } from "@inertiajs/vue3";
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },

  repository: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
  id: null,
  files: [],
});

function handleFileChange(e) {
  form.files = Array.from(e.target.files);
}

watch(
  () => props.repository,
  (newRepo) => {
    if (newRepo) {
      form.id = newRepo.id;
      form.iddok = newRepo.iddok;
      form.files = newRepo.file_path;
    }
  },
  { immediate: true, deep: true }
);
// Close modal
const closeModal = () => {
  emit("update:isOpen", false); // Emit event untuk menutup modal
};

// Handle click outside modal
const handleClickOutside = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

const submit = () => {
  form.post(route("kinerja.updatefile", form.iddok), {
    onSuccess: () => {
      form.reset();
      closeModal();
    },
  });
};
</script>
<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black bg-opacity-50"
    @click="handleClickOutside"
  >
    <div
      class="relative w-full h-auto max-h-[90vh] p-4 overflow-y-auto bg-white rounded-lg sm:w-1/2 sm:p-6"
    >
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-xl font-bold">{{ title }}</h2>
        <button
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="closeModal"
          class="text-gray-500 transition duration-150 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <form class="space-y-6" @submit.prevent="submit">
        <div>
          <InputLabel
            for="gambar"
            value="File"
            class="block text-sm font-medium text-gray-700"
          />
          <input
            type="file"
            multiple
            @change="handleFileChange"
            class="block w-full mt-1 text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer focus:ring-indigo-500 focus:border-indigo-500"
          />
          <progress
            v-if="form.progress"
            :value="form.progress.percentage"
            max="100"
            class="w-full mt-2"
          >
            {{ form.progress.percentage }}%
          </progress>
          <InputError :message="form.errors.file_path" class="mt-2" />
        </div>
        <div class="mt-4">
          <PrimaryBtn :disabled="form.processing">
            <i class="fa-solid fa-floppy-disk"></i> Simpan
          </PrimaryBtn>
        </div>
      </form>
    </div>
  </div>
</template>
